import SimpleDomHole from "./SimpleDomHole";
export default SimpleDomHole;
